import { render, staticRenderFns } from "./InventoryShelfDayForm.vue?vue&type=template&id=3fd88d81&scoped=true&"
import script from "./InventoryShelfDayForm.vue?vue&type=script&lang=js&"
export * from "./InventoryShelfDayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd88d81",
  null
  
)

export default component.exports